import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import MenusListView from "./menus-list.html";
import MenusEditView from "./menus-edit.html";
import MenusItemsEditView from "./menus_items-edit.html";


angular.module("menus", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('menus', {
                url: "/menus",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('menus.list', {
                url: "/list",
                controller: "MenusListCtrl",
                template: MenusListView,
                requiredPermission: ["MENU_READ"]
            })            
            .state('menus.edit', {
                url: "/edit/:id",
                controller: "MenusEditCtrl",
                template: MenusEditView,
                requiredPermission: ["MENU_READ"]
            })
            .state('menus.menu_item-edit', {
                url: "/menu_item/edit/:menu_id/:id",
                controller: "MenusItemsEditCtrl",
                template: MenusItemsEditView,
                requiredPermission: ["MENU_READ"]
            })
    }])
;